module.exports = __webpack_public_path__ + "media/images/temp/icon-2-1c12e111ce09d96f866b574f182b43de.png";